<template>
    <main>
        <Navbar />
        <div class="main">
            <div class="container">
                <div class="overlap" :class="{'overlap-fixed': platform == 'mobile', 'overlap-hide': !overLap}">
                    <div class="mt-3" v-if="platform == 'mobile'">
                        <div class="row">
                            <div class="col">
                                <button class="btn btn-info btn-sm btn-block" @click="overLapToggle">
                                    <i class="fas fa-filter mr-2"></i>{{ overLap ? 'Fechar filtros' : 'Abrir filtros' }}
                                </button>
                            </div>
                        </div>
                    </div><!-- /mt-3 -->
                    <div class="overlap-content">
                        <div class="btn-group w-100" role="group" aria-label="Button group with nested dropdown" :class="{'mt-3': platform == 'mobile'}">
                            <button type="button" class="btn btn-secondary" @click.prevent="selectSport(1)" :class="{'active': sport == 1}" :disabled="sport == 1">
                                <i class="fas fa-futbol mr-2" v-show="platform == 'desktop'"></i>Futebol
                                <span class="badge badge-warning float-right" :class="{'w-100': platform == 'mobile'}" v-show="sport == 1 && events.length > 0">{{events.length}}</span>
                            </button>
                            <button type="button" class="btn btn-secondary" @click.prevent="selectSport(2)" :class="{'active': sport == 2}" :disabled="sport == 2">
                                <i class="fas fa-basketball-ball mr-2" v-show="platform == 'desktop'"></i>Basquete
                                <span class="badge badge-warning float-right" :class="{'w-100': platform == 'mobile'}" v-show="sport == 2 && events.length > 0">{{events.length}}</span>
                            </button>
                            <button type="button" class="btn btn-secondary" @click.prevent="selectSport(3)" :class="{'active': sport == 3}" :disabled="sport == 3">
                                <i class="fas fa-boxing-glove mr-2" v-show="platform == 'desktop'"></i>Lutas
                                <span class="badge badge-warning float-right" :class="{'w-100': platform == 'mobile'}" v-show="sport == 3 && events.length > 0">{{events.length}}</span>
                            </button>
                            <div class="btn-group" role="group">
                                <button id="btnGroupDrop1" type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v mr-2"></i>Mais
                                </button>
                                <div class="dropdown-menu drop-left" aria-labelledby="btnGroupDrop1">
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="selectSport(4)"><i class="fas fa-hockey-puck mr-2"></i>Hóquei</a>
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="selectSport(5)"><i class="fas fa-volleyball-ball mr-2"></i>Voleibol</a>
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="selectSport(6)"><i class="fas fa-tennis-ball mr-2"></i>Tênis</a>
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="selectSport(7)"><i class="fas fa-gamepad-alt mr-2"></i>E-Sports</a>
                                    <div class="dropdown-divider"></div>
                                    <div class="dropdown-header text-center text-uppercase">Filtrar</div>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="search = ''"><i class="fas fa-filter mr-2"></i>Todos</a>
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="search = 'Aguardando'"><i class="fas fa-filter mr-2"></i>Aguardando</a>
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="search = 'Encerrado'"><i class="fas fa-filter mr-2"></i>Encerrado</a>
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="search = 'Adiado'"><i class="fas fa-filter mr-2"></i>Adiado</a>
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="search = 'Cancelado'"><i class="fas fa-filter mr-2"></i>Cancelado</a>
                                </div><!-- /dropdown-menu -->
                            </div><!-- /btn-group -->
                        </div><!-- /btn-group -->
                        <div class="mt-3 mb-3">
                            <div v-show="loading == true" class="alert alert-warning" role="alert">
                                <div class="alert-heading text-center mb-0">
                                    <div class="spinner-border mr-2 align-middle" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span>Carregando, aguarde...</span>
                                </div>
                            </div><!-- /alert-warning -->
                            <div v-show="error.length > 0" class="alert alert-danger" role="alert">
                                <h4 class="alert-heading">Ops, ocorreu um problema!</h4>
                                <hr />
                                <p class="mb-0">{{error}}</p>
                            </div><!-- /alert-danger -->
                            <div v-show="events.length == 0 && nothing_found == true" class="alert alert-info" role="alert">
                                <h4 class="alert-heading">Ops, ocorreu um problema!</h4>
                                <hr />
                                <p class="mb-0">Nenhum evento encontrado, tente novamente!</p>
                                <hr />
                                <div class="form-group mb-0">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">Nova busca</div>
                                        </div>
                                        <input class="form-control" type="date" v-model="newdate" @change="searchDayEvents">
                                    </div>
                                </div>
                            </div><!-- /alert-danger -->
                            <div v-show="events.length > 0 && nothing_found == false">
                                <div class="row ml-0 mb-3 mr-0">
                                    <div class="col pl-0" :class="{'d-contents': platform == 'mobile'}">
                                        <select class="form-control" :class="{'mb-3': platform == 'mobile'}" @change="searchLeague">
                                            <option value="" selected>Selecione uma liga</option>
                                            <option v-for="(item, index) in leaguesOrganizes(events)" :key="index" :value="item.liga">
                                                {{item.liga}}
                                            </option>
                                        </select>
                                    </div><!-- /col -->
                                    <div class="col pl-0" :class="{'d-contents': platform == 'mobile'}">
                                        <input class="form-control" type="text" v-model="search" v-on:keyup.enter="onEnter" :class="{'mb-3': platform == 'mobile'}" placeholder="Buscar time ou liga...">
                                    </div><!-- /col -->
                                    <div class="col pl-0 pr-0" :class="{'d-contents': platform == 'mobile'}">
                                        <input class="form-control" type="date" id="date" @change="searchDayEvents">
                                    </div><!-- /col -->
                                </div><!-- /row -->
                                <div class="row row-head w-100" v-if="platform == 'desktop'">
                                    <div class="col text-truncate">
                                        <i class="fas fa-calendar-alt mr-2"></i>
                                        <span v-show="platform == 'desktop'">Horário</span>
                                    </div><!-- /col -->
                                    <div class="col text-truncate">
                                        <i class="fas fa-long-arrow-alt-down mr-2"></i>
                                        <span v-show="platform == 'desktop'">Mandante</span>
                                    </div><!-- /col -->
                                    <div class="col text-truncate">
                                        <i class="fas fa-long-arrow-alt-up mr-2"></i>
                                        <span v-show="platform == 'desktop'">Visitante</span>
                                    </div><!-- /col -->
                                    <div class="col text-truncate">
                                        <i class="fas fa-cogs mr-2"></i>
                                        <span v-show="platform == 'desktop'">Opções</span>
                                    </div><!-- /col -->
                                </div><!-- /row -->
                            </div><!-- /v-show -->
                        </div><!-- /mt-3 mb-3 -->
                    </div><!-- /overlap-content -->
                </div><!-- /overlap -->
                <div class="mt-3 mb-3" :class="{'mobile': platform == 'mobile'}">
                    <div v-show="events.length > 0 && nothing_found == false">
                        <template v-if="filteredListEvents.length == 0">
                            <div class="alert alert-info mt-3" role="alert">
                                <h4 class="alert-heading">Ops, ocorreu um problema!</h4>
                                <hr />
                                <p class="mb-0">Nenhum evento encontrado, tente novamente!</p>
                            </div><!-- /alert-danger -->                            
                        </template>
                        <template v-else>
                            <collection-cluster v-bind="collection" :items="filteredListEvents" :style="{height: screen_innerHeight + 'px'}" :class="{'desktop': platform == 'desktop'}">
                                <div class="row row-item w-100" slot="item" slot-scope="{ cell, item }" :key="cell.index" :ref="item._id">
                                    <template v-if="cell.index == 0">
                                        <div class="row row-league w-100">
                                            <div class="col-sm-12 text-dark text-truncate font-weight-bold">{{item.liga}}</div>
                                        </div>
                                    </template>
                                    <template v-else-if="item['liga_id'] !== filteredListEvents[cell.index - 1]['liga_id']">
                                        <div class="row row-league w-100">
                                            <div class="col-sm-12 text-dark text-truncate font-weight-bold ">{{item.liga}}</div>
                                        </div>
                                    </template>
                                    <div class="row row-event w-100" :class="{'d-block': platform == 'mobile', 'row-lock': item.bloqueado == 1}">
                                        <div class="col text-truncate" :class="{'text-danger': platform == 'mobile'}">
                                            <span>{{item.horario | formatTimeTable}}</span>
                                            <hr v-if="platform == 'mobile'" />
                                        </div>
                                        <div class="col text-truncate">{{item.time_casa}}</div>
                                        <div class="col text-truncate">{{item.time_fora}}</div>
                                        <div class="col" :class="{'mt-3': platform == 'mobile'}">
                                            <button :class="{'btn-block': platform == 'mobile'}" :id="`btnGroupDropMenuID-${item._id}`" type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="fas fa-ellipsis-v mr-2"></i>Mais
                                            </button>
                                            <div class="dropdown-menu" :aria-labelledby="`btnGroupDropMenuID-${item._id}`">
                                                <div class="dropdown-header text-center text-uppercase">{{findStatus(item.status)}}</div>
                                                <div class="dropdown-divider"></div>
                                                <a class="dropdown-item" href="javascript:void(0);" @click="viewResult(item._id)"><i class="fas fa-poll-h mr-2"></i>Resultados</a>
                                                <a class="dropdown-item" href="javascript:void(0);" @click="viewStatistics(item._id)" v-if="item.esporte == '1'"><i class="fad fa-chart-bar mr-2"></i>Estatísticas</a>
                                                <template v-if="item.status == 0 || item.status == 1">
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" href="javascript:void(0);" @click="cancelEvent(item)"><i class="fas fa-ban mr-2"></i>Cancelar</a>
                                                </template>
                                                <a class="dropdown-item" href="javascript:void(0);" @click="resultEvent(item, index)"><i class="fas fa-edit mr-2"></i>Add. Resultado</a>
                                            </div><!-- /dropdown-menu -->
                                        </div><!-- /col -->
                                    </div><!-- /row -->
                                </div><!-- /row -->
                            </collection-cluster>
                        </template>
                    </div><!-- /div -->
                </div><!-- /mb-3 -->
            </div><!-- /container -->
        </div><!-- /div -->
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    </main><!-- /main -->
</template>

<script>
import {api} from '../api'
import Navbar from './Navbar'
import Swal from 'sweetalert2'
import moment from 'moment-timezone'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CollectionCluster from 'vue-collection-cluster'

const today = moment().tz('America/Recife').format('YYYY-MM-DD');

const heightAdjustMobile = 145;
const heightAdjustDesktop = 270;
const heightAdjust = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? heightAdjustMobile : heightAdjustDesktop;

export default {
    data() {
        return {
            sport: 0,
            error: '',
            search: '',
            events: [],
            newdate: today,
            overLap: true,
            loading: false,
            isLoading: false,
            nothing_found: false,
            screen_w: window.screen.width,
            screen_h: window.screen.height,
            collection: {
                heightType: 'automatic',
                // itemHeight: 742
            },
            screen_innerHeight: window.innerHeight - heightAdjust,
            platform: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop'
        }
    },
    components: {
        Navbar,
        Loading,
        CollectionCluster
    },
    methods: {
        viewResult(id) {

            const self = this;
            const index = self.events.findIndex((obj => obj._id == id));

            try {

                const event = self.events[index];

                Swal.fire(
                    'Resultados',
                    `
                    <div class="row bg-warning mb-2 pt-2 pb-2 rounded">
                        <div class="col text-center text-truncate">${event.time_casa}</div>
                        <div class="col-auto text-center">
                            <i class="fal fa-times"></i>
                        </div>
                        <div class="col text-center text-truncate">${event.time_fora}</div>
                    </div>
                    <div class="row pt-2 pb-2">
                        <div class="col text-center text-info">${this.findStatus(event.status)}</div>
                    </div>
                    <div class="row pt-2 pb-2 border-bottom">
                        <div class="col text-truncate text-left">${event.esporte == '1' ? '90 minutos' : 'Resultado'}</div>
                        <div class="col-auto text-center">
                            <i class="fal fa-arrows-h"></i>
                        </div>
                        <div class="col text-truncate text-right">${event.resultados.ft.casa}-${event.resultados.ft.fora}</div>
                    </div>
                    ${event.esporte == '1' ? `
                        <div class="row pt-2 pb-2 border-bottom">
                            <div class="col text-truncate text-left">Primeiro tempo</div>
                            <div class="col-auto text-center">
                                <i class="fal fa-arrows-h"></i>
                            </div>
                            <div class="col text-truncate text-right">${event.resultados.pt.casa}-${event.resultados.pt.fora}</div>
                        </div>
                        <div class="row pt-2 pb-2 border-bottom">
                            <div class="col text-truncate text-left">Segundo tempo</div>
                            <div class="col-auto text-center">
                                <i class="fal fa-arrows-h"></i>
                            </div>
                            <div class="col text-truncate text-right">${event.resultados.st.casa}-${event.resultados.st.fora}</div>
                        </div>
                        <div class="row pt-2">
                            <div class="col text-center">
                                <small>As informações fornecidas acima são totalmente responsabilidade da nossa provedora <strong class="text-info text-uppercase">${event.servidor}</strong></small>
                            </div>
                        </div>                
                    `: ''}
                    `
                );
            } catch(e) {
                Swal.fire(
                    'Atenção!',
                    'Nenhuma informação disponível para esse evento!',
                    'warning'
                );
            }
        },
        viewStatistics(id) {

            const self = this;
            const index = self.events.findIndex((obj => obj._id == id));

            try {

                let html = '';
                const event = self.events[index];

                event.estatisticas.jogadores.forEach(item => {
                    html += `
                    <div class="row pt-2 pb-2 border-bottom">
                        <div class="col text-truncate text-left">${item.jogador}</div>
                        <div class="col-auto text-center">
                            <i class="fal fa-arrows-h"></i>
                        </div>
                        <div class="col text-truncate text-right">${item.momento} - <span class="text-uppercase">(${item.time.slice(0,3)})</span></div>
                    </div>
                    `;
                });

                Swal.fire(
                    'Estatísticas',
                    `
                    <div class="row bg-warning mb-2 pt-2 pb-2 rounded">
                        <div class="col text-center text-truncate">${event.time_casa}</div>
                        <div class="col-auto text-center">
                            <i class="fal fa-times"></i>
                        </div>
                        <div class="col text-center text-truncate">${event.time_fora}</div>
                    </div>
                    <nav>
                        <div class="nav nav-tabs nav-justified" id="nav-tab" role="tablist">
                            <a class="nav-item nav-link active" id="nav-card-tab" data-toggle="tab" href="#nav-card" role="tab" aria-controls="nav-card" aria-selected="true">Cartões</a>
                            <a class="nav-item nav-link" id="nav-corners-tab" data-toggle="tab" href="#nav-corners" role="tab" aria-controls="nav-corners" aria-selected="false">Escanteios</a>
                            <a class="nav-item nav-link" id="nav-players-tab" data-toggle="tab" href="#nav-players" role="tab" aria-controls="nav-players" aria-selected="false">Jogadores</a>
                        </div>
                    </nav>
                    <div class="tab-content" id="nav-tabContent">
                        <div class="tab-pane fade show active" id="nav-card" role="tabpanel" aria-labelledby="nav-card-tab">
                            <div class="row pt-2 pb-2 border-bottom">
                                <div class="col text-truncate text-left">Total</div>
                                <div class="col-auto text-center">
                                    <i class="fal fa-arrows-h"></i>
                                </div>
                                <div class="col text-truncate text-right">${event.estatisticas.cartoes.total}</div>
                            </div>
                            <div class="row pt-2 pb-2 border-bottom">
                                <div class="col text-truncate text-left">Total casa</div>
                                <div class="col-auto text-center">
                                    <i class="fal fa-arrows-h"></i>
                                </div>
                                <div class="col text-truncate text-right">${event.estatisticas.cartoes.total_casa}</div>
                            </div>
                            <div class="row pt-2 pb-2 border-bottom">
                                <div class="col text-truncate text-left">Total fora</div>
                                <div class="col-auto text-center">
                                    <i class="fal fa-arrows-h"></i>
                                </div>
                                <div class="col text-truncate text-right">${event.estatisticas.cartoes.total_fora}</div>
                            </div>
                            <div class="row pt-2">
                                <div class="col text-center">
                                    <small>As informações fornecidas acima são totalmente responsabilidade da nossa provedora <strong class="text-info text-uppercase">${event.servidor}</strong></small>
                                </div>
                            </div>     
                        </div>
                        <div class="tab-pane fade" id="nav-corners" role="tabpanel" aria-labelledby="nav-corners-tab">
                            <div class="row pt-2 pb-2 border-bottom">
                                <div class="col text-truncate text-left">Total</div>
                                <div class="col-auto text-center">
                                    <i class="fal fa-arrows-h"></i>
                                </div>
                                <div class="col text-truncate text-right">${event.estatisticas.escanteios.total}</div>
                            </div>
                            <div class="row pt-2 pb-2 border-bottom">
                                <div class="col text-truncate text-left">Total casa</div>
                                <div class="col-auto text-center">
                                    <i class="fal fa-arrows-h"></i>
                                </div>
                                <div class="col text-truncate text-right">${event.estatisticas.escanteios.total_casa}</div>
                            </div>
                            <div class="row pt-2 pb-2 border-bottom">
                                <div class="col text-truncate text-left">Total fora</div>
                                <div class="col-auto text-center">
                                    <i class="fal fa-arrows-h"></i>
                                </div>
                                <div class="col text-truncate text-right">${event.estatisticas.escanteios.total_fora}</div>
                            </div>
                            <div class="row pt-2">
                                <div class="col text-center">
                                    <small>As informações fornecidas acima são totalmente responsabilidade da nossa provedora <strong class="text-info text-uppercase">${event.servidor}</strong></small>
                                </div>
                            </div>                    
                        </div>
                        <div class="tab-pane fade" id="nav-players" role="tabpanel" aria-labelledby="nav-players-tab">
                            ${html == '' ? '<div class="mt-3">Nenhuma informação disponível</div>' : html}
                            <div class="row pt-2">
                                <div class="col text-center">
                                    <small>As informações fornecidas acima são totalmente responsabilidade da nossa provedora <strong class="text-info text-uppercase">${event.servidor}</strong></small>
                                </div>
                            </div>  
                        </div>
                    </div>
                    `
                );
            } catch(e) {
                Swal.fire(
                    'Atenção!',
                    'Nenhuma informação disponível para esse evento!',
                    'warning'
                );
            }
        },
        selectSport(sport_id) {

            const self = this;

            self.error = '',
            self.search = '',
            self.events = [];
            self.loading = true;
            self.sport = sport_id;
            self.nothing_found = false;

            document.getElementById('date').value = today;

            api.get(`dashboard/events/${today}/sport/${sport_id}/results`).then((response) => {
                switch(response.data.result) {
                    case 'success':
                        self.overLap = false;
                        self.events = response.data.events.sort((a, b) => {

                            if (self.removeAccents(a.liga) < self.removeAccents(b.liga)) return -1;
                            if (self.removeAccents(a.liga) > self.removeAccents(b.liga)) return 1;

                            if (a.horario < b.horario) return -1;
                            if (a.horario > b.horario) return 1;

                            return 0;
                        });
                    break;
                    case 'nothing_found':
                        self.nothing_found = true;
                    break;
                    default:
                        self.error = response.data.message;
                }
            }).catch((error) => {
                try {
                    self.error = self.network_erros[error.status]['message'];
                } catch(e) {
                    self.error = self.network_erros[408]['message'];
                }
            }).finally(() => {
                self.loading = false;
            });
        },
        leaguesOrganizes(arr) {
            return arr.reduce((unique, o) => {
                if(!unique.some(obj => obj.liga_id === o.liga_id)) {
                    unique.push(o);
                }
                return unique;
            },[]).sort((a, b) => {
                return this.removeAccents(a.liga).localeCompare(this.removeAccents(b.liga))
            });
        },
        searchLeague(event) {
           this.overLap = false;
           this.search = event.target.value;
        }, 
        searchDayEvents(event) {

            const self = this;

            self.error = '',
            self.search = '',
            self.events = [];
            self.loading = true;
            self.nothing_found = false;
            self.sport = self.sport == 0 ? 1 : self.sport;
            
            api.get(`dashboard/events/${event.target.value}/sport/${self.sport}/results`).then((response) => {
                switch(response.data.result) {
                    case 'success':
                        self.overLap = false;
                        self.events = response.data.events.sort((a, b) => {

                            if (self.removeAccents(a.liga) < self.removeAccents(b.liga)) return -1;
                            if (self.removeAccents(a.liga) > self.removeAccents(b.liga)) return 1;

                            if (a.horario < b.horario) return -1;
                            if (a.horario > b.horario) return 1;

                            return 0;
                        });
                    break;
                    case 'nothing_found':
                        //self.sport = 0;
                        self.nothing_found = true;
                    break;
                    default:
                        self.error = response.data.message;
                }
            }).catch((error) => {
                try {
                    self.error = self.network_erros[error.status]['message'];
                } catch(e) {
                    self.error = self.network_erros[408]['message'];
                }
            }).finally(() => {
                self.loading = false;
            });
        },
        cancelEvent(item) {
            
            const self = this;
            let timerInterval;

            Swal.fire({
                title: 'Confirmação',
                html: `Você deseja mesmo cancelar o evento: <br /> <b>${item.time_casa}</b> x <b>${item.time_fora}</b></p> <hr > Lembrando que caso confirme, todas as apostas que contenha esse evento, será <b class="text-danger">recorrigida</b> e o jogo será <b class="text-danger">cancelado</b> da aposta.`,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Sim'
            }).then((result) => {

                if (result.value) {

                    self.isLoading = true;

                    api.put(`dashboard/cancel-event/${item._id}`).then((response) => {
                        switch(response.data.result) {
                            case 'success':
                                Swal.fire({
                                    title: `Aguarde...`,
                                    html: `
                                        <p class="m-0">Iniciando o processo de correção!</p>
                                        <p>Aguarde <b></b> o processo vai iniciar.</p>
                                    `,
                                    timer: 10000,
                                    timerProgressBar: true,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    allowEnterKey: false,
                                    showConfirmButton: false,
                                    showCancelButton: false,
                                    onOpen: () => {
                                        Swal.showLoading()
                                        const b = Swal.getHtmlContainer().querySelector('b')
                                        timerInterval = setInterval(() => {
                                            b.textContent = self.toSecond(Swal.getTimerLeft())
                                        }, 100)
                                    },
                                    onClose: () => {
                                        clearInterval(timerInterval)
                                    }
                                }).then((result) => {
                                    if (result.dismiss === Swal.DismissReason.timer) {
                                        self.bettingCorrection(item._id);
                                    }
                                });
                            break;
                            default:
                                Swal.fire(
                                    'Atenção!',
                                    response.data.message,
                                    'warning'
                                );
                            break;
                        }
                    }).catch((error) => {
                        try {
                            Swal.fire(
                                'Falha',
                                self.network_erros[error.status]['message'],
                                'error'
                            );
                        } catch(e) {
                            Swal.fire(
                                'Falha',
                                self.network_erros[408]['message'],
                                'error'
                            );
                        }
                    }).finally(() => {
                        self.isLoading = false;
                    }); 
                }
            });
        },
        async resultEvent(item, index) {
            
            try {

                let timerInterval;
                let status_state = item.status;

                const self = this;
                const { value: formValues } = await Swal.fire({
                    title: 'Adicionar resultado',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Salvar',
                    html: `
                        <div class="row bg-warning mb-2 pt-2 pb-2 rounded">
                            <div class="col text-center text-truncate">${item.time_casa}</div>
                            <div class="col-auto text-center">
                                <i class="fal fa-times"></i>
                            </div>
                            <div class="col text-center text-truncate">${item.time_fora}</div>
                        </div>

                        <div class="alert alert-warning alert-dismissible fade show" role="alert">
                            <strong>Aviso importante!</strong>
                            <p class="mb-0">Sempre use duas ou mais fontes antes de atualizar qualquer resultado. Alguns sites e apps, podem mostrar dados diferentes.</p>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="text-center ${item.esporte != '3' ? 'clearfix' : 'pb-3 mb-3 border-bottom'}">
                            <h3>${item.esporte != '3' ? 'Placares' : 'Selecione o vencedor'}</h3>    
                        </div>

                        ${item.esporte == '1' ? `

                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link active" id="fulltime-${index}-tab" data-toggle="tab" href="#fulltime-${index}" role="tab" aria-controls="fulltime-${index}" aria-selected="true">90 minutos</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" id="firsttime-${index}-tab" data-toggle="tab" href="#firsttime-${index}" role="tab" aria-controls="firsttime-${index}" aria-selected="false">1º tempo</a>
                                </li>
                            </ul>

                            <div class="tab-content mt-3" id="myTabContent">
                                <div class="tab-pane fade show active" id="fulltime-${index}" role="tabpanel" aria-labelledby="fulltime-${index}-tab">
                                    <div class="row">
                                        <div class="col text-truncate">
                                            <label for="swal-input1" class="d-block text-left mb-0 text-truncate font-weight-bold">${item.time_casa}</label>
                                            <input id="swal-input1" class="swal2-input" autocomplete="off" value="${item.resultados.ft.casa}" spellcheck="false">
                                        </div>
                                        ${self.platform == 'mobile' ? `
                                            <div class="w-100"></div>
                                        ` : `
                                            <div class="col-auto d-flex justify-content-center align-items-center">
                                                <div class="mt-4">
                                                    <i class="fas fa-futbol"></i>
                                                </div>
                                            </div>
                                        `}
                                        <div class="col text-truncate">
                                            <label for="swal-input2" class="d-block text-left mb-0 text-truncate font-weight-bold">${item.time_fora}</label>
                                            <input id="swal-input2" class="swal2-input" autocomplete="off" value="${item.resultados.ft.fora}" spellcheck="false">    
                                        </div>
                                    </div>    
                                </div>
                                <div class="tab-pane fade" id="firsttime-${index}" role="tabpanel" aria-labelledby="firsttime-${index}-tab">
                                    <div class="row">
                                        <div class="col text-truncate">
                                            <label for="swal-input3" class="d-block text-left mb-0 text-truncate font-weight-bold">${item.time_casa}</label>
                                            <input id="swal-input3" class="swal2-input" autocomplete="off" value="${item.resultados.pt.casa}" spellcheck="false">
                                        </div>
                                        ${self.platform == 'mobile' ? `
                                            <div class="w-100"></div>
                                        ` : `
                                            <div class="col-auto d-flex justify-content-center align-items-center">
                                                <div class="mt-4">
                                                    <i class="fas fa-futbol"></i>
                                                </div>
                                            </div>
                                        `}
                                        <div class="col text-truncate">
                                            <label for="swal-input4" class="d-block text-left mb-0 text-truncate font-weight-bold">${item.time_fora}</label>
                                            <input id="swal-input4" class="swal2-input" autocomplete="off" value="${item.resultados.pt.fora}" spellcheck="false">    
                                        </div>
                                    </div>    
                                </div>
                            </div>

                            <div class="text-center">
                                <h3>Estatísticas</h3>    
                            </div>

                            <ul class="nav nav-tabs" id="myTab2" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link active" id="corners-${index}-tab" data-toggle="tab" href="#corners-${index}" role="tab" aria-controls="corners-${index}" aria-selected="true">Escanteios</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" id="cards-${index}-tab" data-toggle="tab" href="#cards-${index}" role="tab" aria-controls="cards-${index}" aria-selected="false">Cartões</a>
                                </li>
                            </ul>

                            <div class="tab-content mt-3" id="myTabContent2">
                                <div class="tab-pane fade show active" id="corners-${index}" role="tabpanel" aria-labelledby="corners-${index}-tab">
                                    <div class="row">
                                        <div class="col text-truncate">
                                            <label for="swal-input5" class="d-block text-left mb-0 text-truncate font-weight-bold">${item.time_casa}</label>
                                            <input id="swal-input5" class="swal2-input" autocomplete="off" value="${self.getStatics(item, 'corners_home')}" spellcheck="false">
                                        </div>
                                        ${self.platform == 'mobile' ? `
                                            <div class="w-100"></div>
                                        ` : `
                                            <div class="col-auto d-flex justify-content-center align-items-center">
                                                <div class="mt-4">
                                                    <i class="fas fa-flag"></i>
                                                </div>
                                            </div>
                                        `}
                                        <div class="col text-truncate">
                                            <label for="swal-input6" class="d-block text-left mb-0 text-truncate font-weight-bold">${item.time_fora}</label>
                                            <input id="swal-input6" class="swal2-input" autocomplete="off" value="${self.getStatics(item, 'corners_away')}" spellcheck="false">    
                                        </div>
                                    </div>    
                                </div>
                                <div class="tab-pane fade" id="cards-${index}" role="tabpanel" aria-labelledby="cards-${index}-tab">
                                    <div class="row">
                                        <div class="col text-truncate">
                                            <label for="swal-input7" class="d-block text-left mb-0 text-truncate font-weight-bold">${item.time_casa}</label>
                                            <input id="swal-input7" class="swal2-input" autocomplete="off" value="${self.getStatics(item, 'cards_home')}" spellcheck="false">
                                        </div>
                                        ${self.platform == 'mobile' ? `
                                            <div class="w-100"></div>
                                        ` : `
                                            <div class="col-auto d-flex justify-content-center align-items-center">
                                                <div class="mt-4">
                                                    <i class="fas fa-diamond"></i>
                                                </div>
                                            </div>
                                        `}
                                        <div class="col text-truncate">
                                            <label for="swal-input8" class="d-block text-left mb-0 text-truncate font-weight-bold">${item.time_fora}</label>
                                            <input id="swal-input8" class="swal2-input" autocomplete="off" value="${self.getStatics(item, 'cards_away')}" spellcheck="false">    
                                        </div>
                                    </div>    
                                </div>
                            </div>
                        ` : `
                            <div class="clearfix">
                                <div class="row">
                                    <div class="col text-truncate">
                                        <label for="swal-input1" class="d-block ${item.esporte != '3' ? 'text-left' : 'text-center'} mb-0 text-truncate font-weight-bold">${item.time_casa}</label>
                                        ${(item.esporte != '1' && item.esporte != '3') ? `
                                            <input id="swal-input1" class="swal2-input" autocomplete="off" value="${item.resultados.ft.casa}" spellcheck="false">
                                        ` : `
                                            <input id="swal-input1" class="swal2-input shadow-none" type="radio" name="result-${index}" autocomplete="off" value="${item.resultados.ft.casa}" ${item.resultados.ft.casa == 1 ? 'checked' : `data-pipe="${index}"`} spellcheck="false">
                                        `} 
                                    </div>
                                    ${self.platform == 'mobile' ? `
                                        <div class="w-100"></div>
                                    ` : `
                                        <div class="col-auto d-flex justify-content-center align-items-center">
                                            <div class="mt-4">
                                                <i class="fal fa-times"></i>
                                            </div>
                                        </div>
                                    `}
                                    <div class="col text-truncate">
                                        <label for="swal-input2" class="d-block ${item.esporte != '3' ? 'text-left' : 'text-center'} mb-0 text-truncate font-weight-bold">${item.time_fora}</label>
                                        ${(item.esporte != '1' && item.esporte != '3') ? `
                                            <input id="swal-input2" class="swal2-input" autocomplete="off" value="${item.resultados.ft.fora}" spellcheck="false">
                                        ` : `
                                            <input id="swal-input2" class="swal2-input shadow-none" type="radio" name="result-${index}" autocomplete="off" value="${item.resultados.ft.fora}" ${item.resultados.ft.fora == 1 ? 'checked' : `data-pipe="${index}"`} "spellcheck="false">
                                        `}    
                                    </div>
                                </div>
                                <div class="d-none">
                                    <input type="hidden" id="swal-input3" value="0">
                                    <input type="hidden" id="swal-input4" value="0">
                                    <input type="hidden" id="swal-input5" value="0">
                                    <input type="hidden" id="swal-input6" value="0">
                                    <input type="hidden" id="swal-input7" value="0">
                                    <input type="hidden" id="swal-input8" value="0">
                                </div>
                            </div>
                        `}

                        <label for="swal-input9" class="d-block text-left mb-0">Status do evento</label>
                        <select id="swal-input9" class="swal2-input w-100">
                            <option value="0" ${item.status == 0 ? 'selected' : ''}>Aguardando</option>
                            <option value="1" ${item.status == 1 ? 'selected' : ''}>Encerrado</option>
                            <option value="3" ${item.status == 3 ? 'selected' : ''}>Adiado</option>
                            <option value="4" ${item.status == 4 ? 'selected' : ''}>Cancelado</option>
                        </select>

                        <label for="swal-input10" class="d-block text-left mb-0">Corrigir apostas</label>
                        <select id="swal-input10" class="swal2-input w-100">
                            <option value="sim">Sim</option>
                            <option value="nao" selected>Não</option>
                        </select>

                        <a href="${self.googleSearchLink(item)}" target="_blank" role="button" class="btn btn-lg btn-success btn-block">
                            <i class="fas fa-search mr-2"></i>Pesquisar no Google    
                        </button>
                    `,
                    focusConfirm: false,
                    preConfirm: () => {
                        return {
                            placar_casa_90: document.querySelector('#swal-input1[type="radio"]') ? (document.querySelector('#swal-input1').checked ? '1' : (document.querySelector('#swal-input2').checked ? '0' : 0)) : String(document.getElementById('swal-input1').value.trim()),
                            placar_fora_90: document.querySelector('#swal-input2[type="radio"]') ? (document.querySelector('#swal-input2').checked ? '1' : (document.querySelector('#swal-input1').checked ? '0' : 0)) : String(document.getElementById('swal-input2').value.trim()),
                            placar_casa_pt: String(document.getElementById('swal-input3').value.trim()),
                            placar_fora_pt: String(document.getElementById('swal-input4').value.trim()),
                            escanteios_casa: String(document.getElementById('swal-input5').value.trim()),
                            escanteios_fora: String(document.getElementById('swal-input6').value.trim()),
                            cartoes_casa: String(document.getElementById('swal-input7').value.trim()),
                            cartoes_fora: String(document.getElementById('swal-input8').value.trim()),
                            status: String(document.getElementById('swal-input9').value),
                            corrigir_apostas: String(document.getElementById('swal-input10').value)
                        }
                    },
                    onOpen: () => {
                        document.getElementById("swal-input1").addEventListener("input", (e) => {
                           return e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        });

                        document.getElementById("swal-input2").addEventListener("input", (e) => {
                           return e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        });

                        document.getElementById("swal-input3").addEventListener("input", (e) => {
                           return e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        });

                        document.getElementById("swal-input4").addEventListener("input", (e) => {
                           return e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        });

                        document.getElementById("swal-input5").addEventListener("input", (e) => {
                           return e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        });

                        document.getElementById("swal-input6").addEventListener("input", (e) => {
                           return e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        });

                        document.getElementById("swal-input7").addEventListener("input", (e) => {
                           return e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        });

                        document.getElementById("swal-input8").addEventListener("input", (e) => {
                           return e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        });
                    }
                });

                if (formValues) {
                    
                    if (formValues.placar_casa_90 == '') {
                        Swal.fire(
                            'Atenção!',
                            `${item.esporte != '3' ? `Informe o placar de 90 minutos do time <b>${item.time_casa}</b>.` : 'Selecione o vencedor.'} `,
                            'warning'
                        );
                    } else if (formValues.placar_fora_90 == '') {
                        Swal.fire(
                            'Atenção!',
                            `${item.esporte != '3' ? `Informe o placar de 90 minutos do time <b>${item.time_fora}</b>.` : 'Selecione o vencendor.'}`,
                            'warning'
                        );
                    } else if (formValues.placar_casa_pt == '') {
                        Swal.fire(
                            'Atenção!',
                            `Informe o placar de 1º tempo do time <b>${item.time_casa}</b>.`,
                            'warning'
                        );
                    } else if (formValues.placar_fora_pt == '') {
                        Swal.fire(
                            'Atenção!',
                            `Informe o placar de 1º tempo do time <b>${item.time_fora}</b>.`,
                            'warning'
                        );
                    } else if (formValues.escanteios_casa == '') {
                        Swal.fire(
                            'Atenção!',
                            `Informe o total de escanteios do time <b>${item.time_casa}</b>.`,
                            'warning'
                        );
                    } else if (formValues.escanteios_fora == '') {
                        Swal.fire(
                            'Atenção!',
                            `Informe o total de escanteios do time <b>${item.time_fora}</b>.`,
                            'warning'
                        );
                    } else if (formValues.cartoes_casa == '') {
                        Swal.fire(
                            'Atenção!',
                            `Informe o total de cartões do time <b>${item.time_casa}</b>.`,
                            'warning'
                        );
                    } else if (formValues.cartoes_fora == '') {
                        Swal.fire(
                            'Atenção!',
                            `Informe o total de cartões do time <b>${item.time_fora}</b>.`,
                            'warning'
                        );
                    } else {

                        self.isLoading = true;
                        
                        item.status = formValues.status;
                        item.resultados.ft.casa = formValues.placar_casa_90;
                        item.resultados.ft.fora = formValues.placar_fora_90;
                        item.resultados.pt.casa = formValues.placar_casa_pt;
                        item.resultados.pt.fora = formValues.placar_fora_pt;

                        var cartoes_total = parseInt(formValues.cartoes_casa) + parseInt(formValues.cartoes_fora);
                        var escanteios_total = parseInt(formValues.escanteios_casa) + parseInt(formValues.escanteios_fora);

                        if (status_state == 1 && item.hasOwnProperty('estatisticas')) {

                            if (item.estatisticas.hasOwnProperty('escanteios')) {
                                item.estatisticas.escanteios.total_casa = formValues.escanteios_casa;
                                item.estatisticas.escanteios.total_fora = formValues.escanteios_fora;
                                item.estatisticas.escanteios.total = escanteios_total;
                                formValues.escanteios_total = escanteios_total;
                            }

                            if (item.estatisticas.hasOwnProperty('cartoes')) {
                                item.estatisticas.cartoes.total_casa = formValues.cartoes_casa;
                                item.estatisticas.cartoes.total_fora = formValues.cartoes_fora;
                                item.estatisticas.cartoes.total = cartoes_total;
                                formValues.cartoes_total = cartoes_total;
                            }
                            
                            if (item.estatisticas.hasOwnProperty('jogadores')) {
                                formValues.jogadores = item.estatisticas.jogadores;
                            } else {
                                formValues.jogadores = [];
                            }
                        } 
                        else 
                        {
                            formValues.jogadores = [];
                            formValues.cartoes_total = cartoes_total;
                            formValues.escanteios_total = escanteios_total;
                        }

                        api.post('dashboard/result', {
                            id: item._id,
                            form: formValues
                        }).then((response) => {
                            switch(response.data.result) {
                                case 'success':
                                    if (formValues.corrigir_apostas == 'sim') {
                                        Swal.fire({
                                            title: `Aguarde...`,
                                            html: `
                                                <p class="m-0">Iniciando o processo de correção!</p>
                                                <p>Aguarde <b></b> o processo vai iniciar.</p>
                                            `,
                                            timer: 10000,
                                            timerProgressBar: true,
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            allowEnterKey: false,
                                            showConfirmButton: false,
                                            showCancelButton: false,
                                            onOpen: () => {
                                                Swal.showLoading()
                                                const b = Swal.getHtmlContainer().querySelector('b')
                                                timerInterval = setInterval(() => {
                                                    b.textContent = self.toSecond(Swal.getTimerLeft())
                                                }, 100)
                                            },
                                            onClose: () => {
                                                clearInterval(timerInterval)
                                            }
                                        }).then((result) => {
                                            if (result.dismiss === Swal.DismissReason.timer) {
                                                self.bettingCorrection(item._id, true);
                                            }
                                        });
                                    } else {
                                        Swal.fire(
                                            'Parabéns!',
                                            'Resultado atualizado com sucesso!',
                                            'success'
                                        );
                                    }
                                break;
                                default:
                                    Swal.fire(
                                        'Atenção!',
                                        response.data.message,
                                        'warning'
                                    ); 
                                break;
                            }   
                        }).catch((error) => {
                            try {
                                Swal.fire(
                                    'Falha',
                                    self.network_erros[error.status]['message'],
                                    'warning'
                                );
                            } catch(e) {
                                Swal.fire(
                                    'Falha',
                                    self.network_erros[408]['message'],
                                    'warning'
                                );
                            }
                        }).finally(() => {
                            self.isLoading = false;
                        });
                    }
                }
            } 
            catch(e) 
            {
                //window.console.log(e.message)
            }
        },
        getStatics(item, option) {
            try {
                if (item.hasOwnProperty('estatisticas')) {
                    if (Object.keys(item.estatisticas).length) {
                        if (option == 'corners_home') {
                            return item.estatisticas.escanteios.total_casa;
                        } else if (option == 'corners_away') {
                            return item.estatisticas.escanteios.total_fora;
                        } else if (option == 'cards_home') {
                            return item.estatisticas.cartoes.total_casa;
                        } else {
                            return item.estatisticas.cartoes.total_fora;
                        }
                    } else {
                        return 0;
                    }
                } else {
                    return 0;
                }
            } catch(e) {
                return 0;
            }
        },
        googleSearchLink(item) {
            return `https://www.google.com/search?q=${encodeURIComponent(item.time_casa + ' x ' + item.time_fora)}`;
        },
        bettingCorrection(id, betting = false) {

            Swal.fire({
                title: 'Corrigindo as apostas',
                html: 'Aguarde... <br /> Esse processo pode demorar um pouco. <hr /> <b class="text-danger">Não saia da página e nem atualize.</b>',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                showConfirmButton: false,
                showCancelButton: false,
                onBeforeOpen: () => {
                    Swal.showLoading()
                }
            });

            api.get(`betting-correction/${id}`, {
                headers: {
                    'X-Betting-Correction': betting
                }
            }).then((response) => {
                switch(response.data.result) {
                    case 'success':
                        Swal.fire(
                            'Parabéns!',
                            response.data.message.replace(/\n/g, "<br />"),
                            'success'
                        );
                    break;
                    default:
                        Swal.fire(
                            'Atenção!',
                            response.data.message,
                            'warning'
                        );
                    break;
                }
            }).catch((error) => {
                try {
                    Swal.fire(
                        'Falha',
                        this.network_erros[error.status]['message'],
                        'error'
                    );
                } catch(e) {
                    Swal.fire(
                        'Falha',
                        this.network_erros[408]['message'],
                        'error'
                    );
                }
            });
        },
        toSecond(ms) {
            return Math.floor((ms/1000) % 60);
        },
        isArray(obj) {
            return Array.isArray(obj);
        },
        removeAccents(str) {
            
            let string = str;
            let map = {a : /[\xE0-\xE6]/g, A : /[\xC0-\xC6]/g, e : /[\xE8-\xEB]/g, E : /[\xC8-\xCB]/g, i : /[\xEC-\xEF]/g, I : /[\xCC-\xCF]/g, o : /[\xF2-\xF6]/g, O : /[\xD2-\xD6]/g, u : /[\xF9-\xFC]/g, U : /[\xD9-\xDC]/g, c : /\xE7/g, C : /\xC7/g, n : /\xF1/g, N : /\xD1/g};

            for (let key in map) {
                 let rex = map[key];
                 string = string.replace(rex, key);
            }

            return string;
        },
        overLapToggle() {
            this.overLap = !this.overLap;
        },
        onEnter() {
            if (this.overLap) this.overLap = false;
        },
    },
    watch: {
        sport() {
            this.newdate = today;
        },
        search(value) {
            if (value.trim().length == 0) this.search = '';
        }
    },
    filters: {
        formatTimeTable(time) {
            return moment(time).tz('America/Recife').format("DD/MM HH:mm");
        }
    },
    computed: {
        filteredListEvents() {
            return this.events.filter((item) => {
                return item.liga.toLowerCase().trim().includes(this.search.toLowerCase().trim()) || item.time_casa.toLowerCase().trim().includes(this.search.toLowerCase().trim()) || item.time_fora.toLowerCase().trim().includes(this.search.toLowerCase().trim()) || item.situacao.toLowerCase().trim().includes(this.search.toLowerCase().trim())
            });
        }
    },
    created() {
        window.addEventListener('resize', () => {
            this.platform = this.isMobile();
        });
    }
}
</script>

<style scoped>
.main {
    margin-top: 80px;
}
.dropdown-toggle:after {
  border: none;
}
.col-sm {
    background-color: #ddd
}
.btn .badge {
    top: 3px!important;
}
.mt-3.mb-3 .row {
    margin-left: 0;
    margin-right: 0;
}
.row-head {
    padding: .75rem;
    background-color: #212529;
    color: #fff;
    vertical-align: bottom;
    text-align: center;
}
.row-league {
    padding: .75rem;
    background-color: #ffc107;
    color: #fff;
    vertical-align: bottom;
    text-align: center;
}
.row-event {
    padding: .75rem;
    color: #fff;
    vertical-align: bottom;
    text-align: center;
}
.row-event .col.text-truncate {
    position: relative;
    z-index: 0;
    top: 3px;
}
.row-event .col.text-truncate hr {
    border-top-color: #666;
}
.row.row-item {
    background-color: #212529;
}
.row.row-item:nth-of-type(odd) {
    background-color: rgba(255,255,255,.05);
}
.row-event.row-lock {
    background-color: rgba(255, 235, 59, 0.2784313725490196);
}
.d-contents {
    display: contents!important;
}
input[type=date]::-webkit-clear-button {
    display: none; /* Hide the button */
    -webkit-appearance: none; /* turn off default browser styling */
}
input[type=date]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
}
.modal-edit-scroll-area {
    width: 100%;
    padding-bottom: 10px;
    overflow: hidden auto;
    height: calc(100% - 56px);
}
.modal-edit-scroll-area::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background: #4b4b4b;
    border-radius: 0;
}
.modal-edit-scroll-area::-webkit-scrollbar-thumb {
    background: #373737;
    border-radius: 0;
}
.modal-edit-close {
    color: #fff;
}
.modal-edit-close:hover {
    color: #ddd;
}
.drop-left {
    margin-left: -100%!important;
}
.collection-cluster {
    overflow-x: auto;
}
.mt-3.mb-3.mobile {
    margin-top: 132px!important;
}
.collection-cluster:not(.desktop) {
    margin-top: 132px;
}
.collection-cluster.desktop::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
.collection-cluster.desktop::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
.collection-cluster.desktop::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border: 0px none #ffffff;
  border-radius: .25rem;
}
.collection-cluster.desktop::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}
.collection-cluster.desktop::-webkit-scrollbar-thumb:active {
  background: #ddd;
}
.collection-cluster.desktop::-webkit-scrollbar-track {
  background: #666666;
  border: 0px none #ffffff;
  border-radius: .25rem;
}
.collection-cluster.desktop::-webkit-scrollbar-track:hover {
  background: #666666;
}
.collection-cluster.desktop::-webkit-scrollbar-track:active {
  background: #333333;
}
.collection-cluster.desktop::-webkit-scrollbar-corner {
  background: transparent;
}
.overlap {
    width: 100%;
    height: 100%;
}
.overlap.overlap-fixed {
    position: fixed;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    background-color: #333;
    right: 0;
    left: 0;
    top: 69px;
    z-index: 1;
}
.overlap.overlap-fixed.overlap-hide {
    height: auto!important;
}
.overlap.overlap-fixed.overlap-hide .overlap-content {
    display: none!important;;
}
</style>